import AdminEventStarts from './starts';

export default AdminEventStarts;